import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function SocialGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'family-&-friends' });
  const activities = useNamedSelector('clarity.activities', { category: 'family-&-friends' });
  return (
    <List tiny-gutter>
      <p>If you look ahead a year from now, what is one thing you would like to have changed in how you are with your family and/or friends (e.g. spend more time together, take a trip, help with homework, meet once a week, etc.). Set a specific goal.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>Choose one thing that you can consistently do to reach your goal. Schedule it and commit to it.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
